import { z } from 'zod'
import { BaseFilter } from './base'

export type DateFilterValue = string

export class DateFilter extends BaseFilter<DateFilterValue> {
  static readonly schema = z.string().datetime()

  parse(urlValue: string): DateFilterValue | null {
    if (!urlValue) {return null}
    return this.safeParse(urlValue)
  }

  serialize(value: DateFilterValue): string {
    return value
  }

  getSchema() {
    return DateFilter.schema
  }
}
